"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDestinationActionService = void 0;
function isDestinationActionService() {
    return (process.env.DESTINATIONS_ACTION_SERVICE === 'true' || process.env.SERVICE_NAME === 'destination-actions-service');
}
exports.isDestinationActionService = isDestinationActionService;
//# sourceMappingURL=isDestinationActionService.js.map